export default "__VITE_ASSET__D80a$wNx__"